import { render, staticRenderFns } from "./UserDepositTable.vue?vue&type=template&id=a180616c&scoped=true"
import script from "./UserDepositTable.vue?vue&type=script&lang=js"
export * from "./UserDepositTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a180616c",
  null
  
)

export default component.exports